// extracted by mini-css-extract-plugin
module.exports = {"logoSantander":"_2MRl29cgXqS4OYuaJv7dH1","containerButton":"_1W2vTm-FJyYF2PDfJNL9VW","container":"K0nI3N9XgR9JcYhwS6luO","containerForm":"_2H4sVPbZU66hMneMtdzfMn"};